const portalHost = process.env.PORTAL_HOST || '';

exports.portalHost = portalHost;
